import { Injector, Type } from '@angular/core';

import { mergeAttributes, Node as TipTapNode } from '@tiptap/core';
import { AngularNodeViewComponent, AngularNodeViewRenderer } from 'ngx-tiptap';

import { APP_TIPTAP_EDITOR_RENDER_AS } from '../tokens';

export type EmailReceiptOptions = {
    HTMLAttributes: Record<string, any>;
};
declare module '@tiptap/core' {
    interface Commands<ReturnType> {
        emailReceipt: {
            insertEmailReceipt: () => ReturnType;
            updateEmailReceipt: () => ReturnType;
        };
    }
}

export const createEmailReceiptExtension = (injector: Injector, component: Type<AngularNodeViewComponent>) => {
    const renderAs = injector.get(APP_TIPTAP_EDITOR_RENDER_AS);

    return TipTapNode.create<EmailReceiptOptions>({
        name: 'emailReceipt',
        inline: false,
        group: 'block',
        selectable: true,
        draggable: true,
        atom: true,

        addOptions() {
            return {
                HTMLAttributes: {},
            };
        },

        parseHTML() {
            return [{ tag: `[data-type="${this.name}"]` }];
        },

        renderHTML({ node, HTMLAttributes }) {
            if (renderAs === 'html') {
                return [
                    'div',
                    mergeAttributes(this.options.HTMLAttributes, {
                        // ...HTMLAttributes,
                        options: HTMLAttributes['options'] || undefined,

                        style: HTMLAttributes['style'],
                        'data-type': this.name,
                    }),
                ];
            }

            return [
                'div',
                mergeAttributes(this.options.HTMLAttributes, {
                    style: HTMLAttributes['style'],
                }),
                '{% for payment in payments %}',
                ['h4', {}, '{{ payment.ProductName}}'],
                [
                    'span',
                    {},
                    'Payment amount for ${{ payment.Amount | format_number:"N0"  }}{{ payment.MerchantCurrency | uppercase }} was received on {{ payment.PaymentDate | time_zone: "Mountain Standard Time" | format_date:"MMMM dd, yyyy h:mm tt", "en-us" }}.',
                ],
                ['br'],
                '{% endfor %}',
            ];
        },

        addNodeView() {
            return AngularNodeViewRenderer(component, { injector });
        },

        addCommands() {
            return {
                insertEmailReceipt:
                    () =>
                    ({ tr, dispatch, editor }) => {
                        const { selection } = tr;
                        const node = this.type.create();

                        if (dispatch) {
                            tr.replaceRangeWith(selection.from, selection.to, node);
                        }

                        return true;
                    },

                updateEmailReceipt:
                    () =>
                    ({ chain, tr }) => {
                        const config: Record<string, string> = {};
                        const node = (tr as any).curSelection?.node;

                        if (!node || node.type.name !== this.name) {
                            return false;
                        }

                        return chain().updateAttributes(this.name, config).run();
                    },
            };
        },
    });
};
